import { Col, Container, Modal as ReactModal, Row } from "react-bootstrap";

import "./modalStyles.css";

const Modal = ({
  size,
  title,
  bodyContent,
  showFooter,
  buttonFooterLabel,
  buttonFooterOnPress,
  buttonFooterDisabled,
  footerLabel,
  displayModal,
  setDisplayModal,
  setOnEnter,
}) => (
  <ReactModal
    size={size}
    show={displayModal}
    onHide={() => setDisplayModal(false)}
    onEnter={() => {
      if (setOnEnter) {
        setOnEnter();
      }
    }}
    centered
  >
    <ReactModal.Header closeButton className="geo-modal-header">
      <ReactModal.Title className="geo-modal-title mx-auto">
        {title}
      </ReactModal.Title>
    </ReactModal.Header>
    <ReactModal.Body className="geo-modal-body">{bodyContent}</ReactModal.Body>
    {showFooter && (
      <ReactModal.Footer className="geo-modal-footer">
        <Container>
          <Row>
            <Col xs={12}>
              <button
                className="geo-modal-footer-button mx-auto w-100"
                disabled={buttonFooterDisabled}
                onClick={buttonFooterOnPress}
              >
                {buttonFooterLabel}
              </button>
            </Col>
          </Row>
          <Row className="justify-content-center">
            <span className="geo-modal-footer-text text-center">
              {footerLabel}
            </span>
          </Row>
        </Container>
      </ReactModal.Footer>
    )}
  </ReactModal>
);

export default Modal;
